import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

interface IconProps {
  icon: IconProp;
  size?: SizeProp;
  className?: string;
  title?: string;
  'aria-label'?: string;
}

const Icon: React.FC<IconProps> = ({
  icon,
  size = '1x',
  className = '',
  title,
  'aria-label': ariaLabel,
  ...props
}) => {
  return (
    <FontAwesomeIcon
      icon={icon}
      size={size}
      className={className}
      title={title}
      aria-label={ariaLabel}
      {...props}
    />
  );
};

export default Icon;